import {z} from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore/firestoreTimestampToDateSchema';
import {tradeMessageDbSchema} from './tradeMessageDbSchema';

export const tradeMessageSchema = tradeMessageDbSchema
  .omit({
    createdAt: true,
  })
  .extend({
    createdAt: firestoreTimestampToDateSchema,
  });

export type TradeMessage = z.infer<typeof tradeMessageSchema>;
